import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds(
  'apps-admin-web-components-ReactFlow-tiptap-simulation-dBlock',
  [
    'speedMenuButton',
    'speedOption',
    'skipAnimationButton',
    'restartButton',
    'languageTrigger',
    'languageOption',
    'languageOptionHint',
    'languageFooterNote',
  ],
);
